export default "__VITE_ASSET__kDxGeTul__"